import { Spin } from "antd";
import React, { useEffect, useState } from "react";

type Props = {
  isLoading?: boolean;
  fullscreen?: boolean;
  count?: number;
  max?: number;
  maxWidth?: number;
  isShowCounter?: boolean;
  message?: string;
};

export const Loader: React.FC<Props> = ({
  isLoading = false,
  count = 0,
  max = 1,
  isShowCounter = false,
  maxWidth,
}) => {
  const [step, setStep] = useState<number>(0);
  useEffect(() => {
    setStep(count);
  }, [count]);

  return (
    <div
      style={{
        position: "fixed",
        ...loadingStyles.container,
        display: isLoading ? "flex" : "none",
      }}
    >
      <div style={loadingStyles.loadingText(isShowCounter, maxWidth)}>
        {isShowCounter ? (
          <span>
            Chargement... {step}/{max}
          </span>
        ) : (
          <Spin size="large" />
        )}
      </div>
    </div>
  );
};

const loadingStyles = {
  container: {
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(243, 243, 243, 0.5)",
    zIndex: 9999999999,
    top: 0,
    left: 0,
    width: "100%",
    height: "100vh",
    display: "none",
  },
  loadingText: (isShowCounter?: boolean, maxWidth?: number) => ({
    padding: "7px 20px",
    borderRadius: 7,
    marginTop: 30,
    maxWidth: maxWidth ? maxWidth : isShowCounter ? 300 : 250,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }),
};
